import { render } from "./AppLayout.vue?vue&type=template&id=bd6a947a&ts=true"
import script from "./AppLayout.vue?vue&type=script&lang=ts"
export * from "./AppLayout.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__